import { SwapHorizOutlined } from '@mui/icons-material'

import { getIsSwitchTenantFeatureEnabled } from '@tabeeb/modules/appConfigState/selectors'
import { useSelector } from '@tabeeb/store'
import { useDialogState, NavbarItem } from '@collaborate-health/uikit'

import SwitchTenantContainer from '@tabeeb/modules/account/containers/SwitchTenantContainer'

const SwitchTenantButton: React.FC = () => {
  const [open, onOpen, onClose] = useDialogState()

  const display = useSelector(getIsSwitchTenantFeatureEnabled)
  if (!display) {
    return null
  }

  return (
    <>
      <NavbarItem name='Switch tenant' icon={<SwapHorizOutlined />} onClick={onOpen} />
      <SwitchTenantContainer open={open} onClose={onClose} dialog />
    </>
  )
}

export default SwitchTenantButton

